var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"accordion-item d-flex flex-nowrap align-items-baseline"},[_c('span',{staticClass:"icon-chevron"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.href}},[_vm._t("default")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-615a5ac2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/AccordionItem.vue
// module id = C3bO
// module chunks = 0